import BaseMatcherController from "./base_matcher_controller"

export default class extends BaseMatcherController {
  static targets = [
    "previousLink",
    "stepContent",
    "ineligibleContent",
    "requiredText",
    "stepText",
  ]

  // Generic input validation, plus radio-required handling for steps that
  // include a radio group.
  validate(event) {
    event.preventDefault()
    const stepContent = this.stepFor(event)
    if (!stepContent) return

    let valid = this.checkFieldValidity(stepContent)

    const radioButton = stepContent.querySelector("input[type='radio']")
    if (this.isVisible(radioButton)) {
      const selectedValue = this.selectedRadioValue(stepContent)
      const requiredText = this.requiredTextFor(stepContent)

      if (selectedValue?.length > 0) {
        this.toggleRequired(requiredText, false)
      } else {
        valid = false
        this.toggleRequired(requiredText, true)
      }
    }

    if (valid) {
      this.nextStep()
    }
  }

  // "Does this person already have an ABLE account?" — yes → ineligible
  validateAlreadyHasAccount(event) {
    event.preventDefault()
    const stepContent = this.stepFor(event)
    if (!stepContent) return
    const requiredText = this.requiredTextFor(stepContent)
    const selectedValue = this.selectedRadioValue(stepContent)

    if (!selectedValue) {
      this.toggleRequired(requiredText, true)
      return
    }

    this.toggleRequired(requiredText, false)
    if (selectedValue === "yes") {
      this.showIneligible("already_has_account")
    } else {
      this.nextStep()
    }
  }

  // "Onset before age 46?" — after → ineligible
  validateOnsetAge(event) {
    event.preventDefault()
    const stepContent = this.stepFor(event)
    if (!stepContent) return
    const requiredText = this.requiredTextFor(stepContent)
    const selectedValue = this.selectedRadioValue(stepContent)

    if (!selectedValue) {
      this.toggleRequired(requiredText, true)
      return
    }

    this.toggleRequired(requiredText, false)
    if (selectedValue === "after") {
      this.showIneligible("onset_age")
    } else {
      this.nextStep()
    }
  }

  // "Disability criteria" — none of the above → ineligible
  validateDisabilityCriteria(event) {
    event.preventDefault()
    const stepContent = this.stepFor(event)
    if (!stepContent) return
    const requiredText = this.requiredTextFor(stepContent)
    const selectedValue = this.selectedRadioValue(stepContent)

    if (!selectedValue) {
      this.toggleRequired(requiredText, true)
      return
    }

    this.toggleRequired(requiredText, false)
    if (selectedValue === "none") {
      this.showIneligible("criteria")
    } else {
      this.goToStepWithKey("investmentApproach")
    }
  }
}
